module.exports = require('../impls/$first-or/first-or.js').__firstOr;